import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface IProductUsage {
    label: string;
    content: string;
    type: string;
}

export class ProductUsage {
    @observable public label: string = '';
    @observable public content: string = '';
    @observable public type: string = '';

    public static fromJson(productUsage: IProductUsage): ProductUsage {
        const newProductUsage = new ProductUsage();
        copyPropertiesExcludeNullsAndGetters(newProductUsage, productUsage);

        return newProductUsage;
    }
}
